import request from './financeRequest'

export { transactionApi } from './transactions'
export { commissionApi } from './commission'
export { ledgerApi } from './ledger'
export { ledgerApi as expenseApi } from './ledger'
export { organizationApi } from './organization'
export { reportApi } from './reports'

export const financeAuthApi = {
  login: (data) => request.post('/finance/auth/login', data),
  me: () => request.get('/finance/auth/me'),
  logout: () => request.post('/finance/auth/logout'),
}

export const dashboardApi = {
  summary: () => request.get('/finance/dashboard/summary'),
  branches: () => request.get('/finance/dashboard/branches'),
}

export const moduleApi = {
  list: (module) => request.get(`/finance/${module}`),
  createReceipt: (data) => request.post('/finance/receipts', data),
  confirmReceipt: (id) => request.post(`/finance/receipts/${id}/confirm`),
  createIncome: (data) => request.post('/finance/other-income', data),
  createAccount: (data) => request.post('/finance/accounts', data),
  closeMonth: (data) => request.post('/finance/month-closes', data),
}
